import { inject, Pipe, PipeTransform } from "@angular/core";
import { dateUtil } from "src/app/support/date-util";
import { isUndefined } from "lodash-es";
import { RegionService } from "src/app/services/feature-access-control/region.service";

@Pipe({
  name: "dayjs",
  standalone: false
})
export class DayjsPipe implements PipeTransform {
  private readonly regionService = inject(RegionService);

  transform(
    value: Date | string | number | undefined,
    format?: string,
    parseFormat?: string
  ): string | null {
    if (!value && isUndefined(value)) {
      return null;
    }

    return dateUtil(value, parseFormat)
      .locale(this.regionService.getLocale())
      .format(format || "L");
  }
}
